"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
exports.defaultOptions = {
    maxSize: 720,
    quality: undefined,
    type: 'image/jpeg',
};
